module.exports = __webpack_public_path__ + "media/images/favicons_staging/favicon-32x32-27de80158331e0d2479935bfaa78ea05.png";